import { replaceText } from "@jog/shared"
import React, { PropsWithChildren, ReactHTML, createContext, useCallback, useContext } from "react"

interface I18nContextState {
    translations: Record<string, string>
}

export const I18nCtx = createContext<I18nContextState>({
    translations: {},
})

export const useI18nCtx = () => useContext(I18nCtx)!

export const useI18n = () => {
    const { translations } = useI18nCtx()
    const $t = useCallback(
        (key: string, replace: Record<string, string> = {}) => {
            if (!translations?.[key]) return replaceText(key, replace) || key
            return replaceText(translations?.[key], replace) || `${key}`
        },
        [translations]
    )
    return { $t }
}

export const I18n = ({ t, as }: PropsWithChildren<{ t: string; as?: keyof ReactHTML }>) => {
    const { $t } = useI18n()
    if (!as) return <>{$t(t)}</>
    return React.createElement(as, {}, <>{$t(t)}</>)
}
